<template>
    <main>
        <div class="form-signin" v-if="mode == 1">
            По этому приглашению учетная запись уже создана.
        </div>
        <div class="form-signin" v-else-if="mode == 2">
            Сейчас Вам предстоит создать <strong>ОСНОВНУЮ</strong> учетную запись которая будет обладать всеми возможными правами в Интернет-магазине.
            <br /><br /><strong>Для продолжения работы необходимо присутствие сотрудника обладающего
            полномочиями принятия решений.</strong> Если в данный момент нет сотрудников обладающих полномочиями, то закройте страницу, дождитесь появления сотрудника и вернитесь к созданию учетной записи в его присутствии.<br /><br />

            <div class="checkbox mb-2 text-center">
                <input type="checkbox" id="iReadIt" class="mr-2" v-model="readed" /><label for="iReadIt">Я прочитал текст полностью</label>
            </div>

            <button type="button" class="createNewAuthData btn btn-lg btn-primary btn-block" @click="switchToForm()">
                У меня есть полномочия, приступить к созданию
            </button>

        </div>
        <div class="form-signin" v-else-if="mode == 3">
            Уважаемый клиент!
            В рамках повышения качества обслуживания и расширения функциональных возможностей
            компания КАТРИС инициировала процедуру создания учетных записей Интернет-магазина
            нового образца.<br /><br />
            Сейчас или в ближайшем будущем Вам предстоит создать <strong>ОСНОВНУЮ</strong> учетную запись которая будет обладать всеми возможными правами в Интернет-магазине.
            <br /><br />
            Текущая учетная запись будет заблокирована и не сможет быть использована для входа

            <br /><br /><strong>Для продолжения работы необходимо присутствие сотрудника обладающего
            полномочиями принятия решений.</strong><br />

            <div class="checkbox mb-2 text-center">
                <input type="checkbox" id="iReadIt2" /><label for="iReadIt">Я прочитал текст полностью</label>
            </div>

            <a class="returnTooldStyle" href="/">Уполномоченного сотрудника сейчас нет</a>

            <button class="createNewAuthData form-control">У меня есть полномочия, приступить к созданию</button>
        </div>
        <div class="form-signin" v-else-if="mode == 4">
            <table>
                <tr height=30px>
                    <td align="right" width='50%'>Имя пользователя</td>
                    <td colspan="2" >
                        <input readonly onfocus="this.removeAttribute('readonly')" autocomplete="new-password" type="text" id="login" name="login" v-model="login" @change="checkLogin()" />
                    </td>
                    <td width=10%>
                        <i v-if="loginChecked && validLogin" style="color: green; font-size: 24px;" class="las la-check"></i>
                        <i v-else-if="loginChecked && !validLogin" style="color: red; font-size: 24px;" class="las la-exclamation-triangle"></i>
                    </td>
                </tr>
                <tr>
                    <td class="loginTypeDescription" colspan="4" style=" font-size: 76%;" align=center>
                        Русские или латинские буквы, цифры. Возможно использование адреса EMail.<br />Не менее трех символов.</td>
                </tr>
                <tr>
                    <td align="right">Пароль</td>
                    <td colspan="2">
                        <input v-if="!showPassword" autocomplete="new-password" type="password" name="password" v-model="password" />
                        <input v-else type="text" autocomplete="new-password" name="password" v-model="password" />
                        <i @click="passwordShow()" class="las la-eye eye"></i>


                    </td>
                    <td>

                    </td>
                </tr>
                <tr>
                    <td class="passwordTypeDescription" colspan="4" style=" font-size: 76%;" align=center>
                        Минимальная длина пароля – восемь символов. Не рекомендуем использовать пароли от других сайтов или слова, которые злоумышленники смогут легко подобрать.
                    </td>
                </tr>
                <tr>
                    <td align="right">EMail</td>
                    <td colspan="2">
                        <input type="email" id="email" name="email" v-model="email" />
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td class="emailTypeDescription" colspan="4" style=" font-size: 76%;" align=center>
                        Должен быть указан действующий адрес электронной почты. Может быть использован при восстановлении пароля.
                    </td>
                </tr>
                <tr>
                    <td align="center" colspan="4">
                        <br />
                        <button class="createNewAcc btn btn-lg btn-primary btn-block" type="button" @click="createAccount()">
                            Создать учетную запись
                        </button>
                    </td>
                </tr>
            </table>
        </div>
        <div class="form-signin" v-else-if="mode == 5">
            <div v-html="resultMessage"></div>
        </div>
    </main>
</template>

<script>
    import makePost from '../js/makePost';

    export default {
        name: "mknewlogin",
        metaInfo: {
            title: 'Подтверждение регистрации',
            titleTemplate: '%s - sale.katris'
        },
        props: ['inviteKey'],
        data() {
            return {
                readed: false,
                mode: 0,
                showPassword: false,
                login: '',
                loginChecked: false,
                validLogin: false,
                password: '',
                email: '',
                resultMessage: '',
                contragentId: 0
            }
        },
        created() {
            let self = this;

            if (self.inviteKey.length >= 50) {
                makePost('katrisService', 'checkInvite', {key: self.inviteKey}, null, function(response) {
                    console.log(response)

                    if (response.status === 'OK') {
                        if (response.data.alreadyDone) {
                            self.mode = 1;
                        } else if (response.data.contragentId) {
                            self.mode = 2;
                            self.email = response.data.email;
                            self.contragentId = response.data.contragentId;
                        }
                    }
                });
            } else {
                document.location.href = '/';
            }
        },
        methods: {
            switchToForm() {
                let self = this;

                if (!self.readed) {
                    alert('Для продолжения нужно прочитать текст полностью');
                } else {
                    self.mode = 4;
                }
            },
            passwordShow: function() {
                this.showPassword = !this.showPassword;
            },
            createAccount() {
                let self = this;
                if (this.login.length >= 3 && this.validLogin && this.email.length >= 6 && this.password.length >= 8) {
                    makePost('katrisService', 'acceptInvite', {
                        key: self.inviteKey,
                        login: self.login,
                        password: self.password,
                        email: self.email,
                        contragentId: self.contragentId,
                        regOn: true
                    }, null, function(response) {
                        console.log(response)
                        if (response.status === 'OK') {
                            self.mode = 5;
                            self.resultMessage = response.data;
                        }
                    });
                } else {
                    alert('Не все поля верно заполнены!')
                }
            },
            checkLogin() {
                let self = this;
                if (this.login.length >= 3) {
                    makePost('katrisService', 'checkLogin', {login: self.login}, null, function(response) {
                        if (response.status === 'OK') {
                            console.log(response)
                            self.loginChecked = true;
                            if (response.data == 1) {
                                self.validLogin = false;
                            } else {
                                self.validLogin = true;
                            }
                        }
                    });
                }
            }
        }
    }
</script>

<style scoped>
    @import "./../assets/css/newLogin.css";

    .form-signin {
        width: 600px;
        /*height: 400px;*/
        padding: 15px;
        margin: auto;

        border-radius: 21px;

        -webkit-box-shadow: 0 0 10px 0 rgba(0,0,0,.8);
        box-shadow: 0 0 10px 0 rgba(0,0,0,.8);
        -webkit-box-shadow: 5px 5px 20px 0px rgba(0,0,0,.6);
        box-shadow: 5px 5px 20px 0px rgba(0,0,0,.6);

        /*background-image: url("./../assets/img/logo-katris.png");*/
        /*background-repeat: no-repeat;*/
        /*background-size: 30%;*/
    }

    .eye {
        cursor: pointer;
        font-size: 16px;
    }

    input {
        padding-left: 5px !important;
    }

    button {
        font-size: 16px;
    }
</style>